import React from 'react';
import DataTable from '../../components/DataTable';
import useAsync from '../../hooks/useAsync';
import { deleteAsset, getArchivedAssets, unarchiveAsset } from '../../api';
import moment from 'moment';
import Banner from '../../components/Banner';

const ArchivedAssets = () => {
	const { value: assets, execute: onRefreshAssets } =
		useAsync(getArchivedAssets);
	const { execute: onUnarchive } = useAsync(unarchiveAsset, {
		immediate: false,
	});
	const { execute: onDelete } = useAsync(deleteAsset, {
		immediate: false,
	});
	return (
		<div>
			<Banner status="warning" className={'rounded-xl mb-6'} size="xs">
				Warning: Assets older than 30 days are subject to be deleted. This
				include all associated data
			</Banner>

			<h2 className="text-base font-semibold leading-6 text-gray-900">
				Archived Assets
			</h2>
			<p className="mt-1 text-sm text-gray-500 mb-6"></p>

			<DataTable
				className="mb-20"
				data={assets}
				columns={[
					{
						header: 'Manufacturer',
						accessorKey: 'manufacturer.name',
						cell: (info) => info?.getValue() || null,
					},
					{
						header: 'Model',
						accessorKey: 'model.name',
						cell: (info) => info?.getValue() || null,
					},
					{
						header: 'Serial Number',
						accessorKey: 'serialNumber',
						cell: (info) => info?.getValue() || null,
					},
					{
						header: 'Archived',
						accessorKey: 'archivedAt',
						cell: (info) =>
							info?.getValue() ? `${moment(info?.getValue()).fromNow()}` : null,
					},
				]}
				rowActions={[
					{
						name: 'Unarchive',
						onClick: (row) =>
							onUnarchive({ id: row?.original?.id }, () => onRefreshAssets()),
					},
					{
						name: 'Delete Permanently',
						onClick: (row) =>
							onDelete({ id: row?.original?.id }, () => onRefreshAssets()),
						danger:
							'Are you sure you want to permanently delete this asset?  There is no turning back',
					},
				]}
				useExport={false}
				usePagination={false}
				hasCheckboxes={false}
			/>
		</div>
	);
};

export default ArchivedAssets;
